import { useFSBooleanFlag } from "./useFSBooleanFlag";
export var useFSCheckBooleanFlag = function (flag, defaultValue) {
    if (defaultValue === void 0) { defaultValue = true; }
    return useFSBooleanFlag()(flag, defaultValue);
};
